import { MachinesListDataTypes } from "@common/types/machines-list-types";
import apiUseCases from "@src/cloud-connect/api";
import { postVPNRequestSupportSessionDto } from "@src/cloud-connect/api/vpn-manager/vpn-post-request-support-session";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";

export const postVPNRequestSupportSessionUseCase = async (
  payload: postVPNRequestSupportSessionDto,
): Promise<{
  success: boolean;
  data?: MachinesListDataTypes;
  error?: { status?: number; data?: { msg?: string }; message?: string };
}> => {
  try {
    const response = await apiUseCases.postVPNRequestSupportSession(payload);

    return {
      success: true,
      data: response,
    };
  } catch (error) {
    const { message, status, data } = parseAxiosApiError(
      error,
      "Failed to request support session.",
    );
    return {
      success: false,
      error: {
        status,
        data: data as { msg?: string } | undefined,
        message,
      },
    };
  }
};
